<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="9" class="pa-0 d-flex flex-column h-100">
            <div>
                <v-tabs v-model="activePage" color="secondary">
                    <v-tab value="employee">اطلاع رسانی کاربر سازمانی</v-tab>
                    <v-tab value="customer">اطلاع رسانی مشتری</v-tab>
                </v-tabs>
            </div>
            <p class="text-small text-grey-darken-1 mt-3">در سامانه هلپیکال برای عملیات‌های متفاوت روی تیکت، به {{activePage == 'employee' ? 'کاربر سازمانی' : 'مشتری'}} مربوطه اطلاع‌رسانی انجام ‌می‌شود. شما همواره می‌توانید با انتخاب یا عدم انتخاب هر یک از روش‌های اطلاع‌رسانی برای هر عملیات آن را سفارشی‌سازی کنید.<br>برای تعریف متن پیام اطلاع‌رسانی بر روی قسمت ویرایش در انتهای هر ردیف از جدول کلیک کنید.</p>
            <v-data-table
                :headers="headers"
                :items="rows.filter(x => x.name.endsWith(activePage))"
                calculate-widths
                density="comfortable"
                class="flex-grow-1 overflow-y-auto"
                :row-props="({index}) => Object.create({style: {'background-color': index % 2 == 0 ? '#f6f6f6' : ''}})"
                hide-default-footer
                :items-per-page="20"
                fixed-header
                mobile-breakpoint="700"
            >
                <template #[`item.${type}`]="{ item }" v-for="type in noticeTypes">
                    <v-checkbox
                        :disabled="item[type] === null"
                        :indeterminate="item[type] === null"
                        hide-details
                        v-model="item[type]"
                    ></v-checkbox>
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-btn
                        @click="openNoticeMessagesDialog(item)"
                        class="rounded"
                        variant="tonal"
                        icon="edit"
                        color="secondary"
                        size="small"
                        :disabled="!$system.license.features.notice_custom_text || !noticeTypes.filter(x => Object.hasOwn(item, x + '_message')).length"
                    >
                    </v-btn>
                </template>
            </v-data-table>
            <div class="mt-5">
                <v-btn @click="submit" color="success" :loading="loading">ثبت اطلاعات</v-btn>
                <v-btn @click="$router.push({path: '/settings'})" class="ms-3" color="error" variant="text" :disabled="loading">بازگشت به تنظیمات</v-btn>
            </div>
        </v-col>
    </div>
    <v-dialog persistent v-model="noticeMessageDialog" width="650">
        <v-card tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">ویرایش متن {{ notice.title }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="noticeMessageDialog = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="px-sm-4 px-2 mt-2 text-grey-darken-2" style="min-height:340px; overflow-y:auto; scrollbar-width:thin">
                <v-row align="center" class="ma-0" justify="space-between">
                    <v-col class="text-small text-grey-darken-2 font-weight-medium px-0" cols="auto">روش اطلاع‌رسانی</v-col>
                    <v-col cols="auto" class="pe-0">
                        <v-btn v-for="(type, index) in noticeTypes.filter(x => Object.hasOwn(notice, x + '_message'))" :key="index" @click="activeTypeMessage = type" color="secondary" class="ms-1" :variant="activeTypeMessage == type ? 'flat' : 'tonal'">{{type}}</v-btn>
                    </v-col>
                </v-row>
                <div class="mx-1 mt-3">
                    <v-textarea
                        v-for="(type, index) in noticeTypes.filter(x => Object.hasOwn(notice, x + '_message'))"
                        :rules="$validation('required')"
                        :key="index"
                        label="پیام"
                        no-resize
                        :ref="'noticeMessage_' + type"
                        rows="5"
                        v-model="notice[type + '_message']"
                        v-show="activeTypeMessage === type"
                    ></v-textarea>
                    <div class="justify-space-between align-center px-2 border border-b-0 rounded rounded-b-0 d-flex bg-blue-grey-lighten-5">
                        <p class="col-auto text-secondary text-small font-weight-bold user-select-none d-inline-block">
                            <v-icon class="me-2" size="18">icon-parameter</v-icon>پارامتر های داینامیک
                        </p>
                        <v-btn @click="resetToDefault" class="px-0 text-small" color="secondary" variant="text">بازگشت به متن پیش‌فرض</v-btn>
                    </div>
                    <v-expand-transition>
                        <div class="d-flex border rounded-b border-t-0">
                            <v-tabs color="secondary" :items="Object.keys(noticeVariables[notice.name]?.variables)" direction="vertical">
                                <template v-slot:tab="{ item }">
                                    <v-tab class="border-e-md" :value="item.text">{{ item.text }}</v-tab>
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-tabs-window-item :value="item.text">
                                        <v-chip-group column class="pa-2">
                                            <v-chip @click="addTemplate(itemKey)" v-for="(itemValue, itemKey) in noticeVariables[notice.name]?.variables[item.text]">{{ itemValue }}</v-chip>
                                        </v-chip-group>
                                    </v-tabs-window-item>
                                </template>
                            </v-tabs>
                        </div>
                    </v-expand-transition>
                </div>
            </div>
            <v-card-actions class="pb-4 px-5 mt-4">
                <v-btn @click="submitNoticeMessageDialog" color="success">ثبت اطلاعات</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="noticeMessageDialog = false" color="error" variant="text">انصراف</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import noticeVariables from "@/variables/noticeVariables";
export default {
    title: "شیوه‌های اطلاع‌رسانی",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            noticeMessageDialog: false,
            loading: false,
            activePage: 'employee',
            headers: [
                {
                    title: "عنوان عملیات‌های اطلاع‌رسانی",
                    sortable: false,
                    value: "title",
                    minWidth: "420px",
                },
                {
                    title: "SMS",
                    value: "sms",
                    sortable: false,
                    width: "10%",
                },
                {
                    title: "Email",
                    value: "email",
                    sortable: false,
                    width: "10%",
                },
                {
                    title: "Telegram",
                    value: "telegram",
                    sortable: false,
                    width: "10%",
                },
                {
                    title: "Desktop notification",
                    value: "webpush",
                    sortable: false,
                    width: "10%",
                },
                {
                    title: "Webhook",
                    value: "webhook",
                    sortable: false,
                    width: "10%",
                },
                {
                    value: "actions",
                    sortable: false,
                    width: "5%",
                },
            ],
            rows: [],
            noticeTypes: ["sms", "email", "telegram", "webpush", "webhook"],
            activeTypeMessage: "sms",
            notice: {},
            noticeVariables: noticeVariables(),
        };
    },
    methods: {
        submit() {
            this.loading = true;
            let form = {_method: 'put'};
            this.rows.forEach((el) => {
                this.noticeTypes.forEach((type) => {
                    if (el[type] !== null)
                        Object.assign(form, {[`${el.name}_${type}_active`]: el[type]});
                });
            });
            this.$updateSettings(form).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.getData();
                }
            }).finally(()=>{this.loading = false});
        },
        submitNoticeMessageDialog() {
            if (this.noticeTypes.filter(x => Object.hasOwn(this.notice, x + '_message') && !this.$refs['noticeMessage_' + x][0]?.isValid).length) {
                this.activeTypeMessage = this.noticeTypes.find(x => Object.hasOwn(this.notice, x + '_message') && !this.$refs['noticeMessage_' + x][0]?.isValid);
            } else {
                let form = {};
                this.noticeTypes.forEach((type) => {
                    if (Object.hasOwn(this.notice, type + '_message'));
                        Object.assign(form, {[`${this.notice.name}_${type}_message`]: this.notice[type + '_message']});
                });
                form._method = 'put';
                this.$updateSettings(form).then(async (res) => {
                    if (res && res.status == "UPDATED") {
                        this.$toast.success(res.message);
                        this.noticeMessageDialog = false;
                        this.getData();
                    }
                });
            }
        },
        resetToDefault() {
            this.$defaultSettings({
                defaults: [`${this.notice.name}_${this.activeTypeMessage}_message`],
            }).then((res) => {
                if (res && res.status == "OK")
                    this.notice[`${this.activeTypeMessage}_message`] = res.data[`${this.notice.name}_${this.activeTypeMessage}_message`];
            });
        },
        openNoticeMessagesDialog(item) {
            this.activeTypeMessage = Object.hasOwn(item, 'sms_message') ? 'sms' : Object.hasOwn(item, 'email_message') ? 'email' : 'telegram';
            this.notice = { ...item };
            this.noticeMessageDialog = true;
        },
        addTemplate(item) {
            let position = this.$refs['noticeMessage_' + this.activeTypeMessage][0].$el.querySelector("textarea").selectionStart;
            this.notice[`${this.activeTypeMessage}_message`] = [this.notice[`${this.activeTypeMessage}_message`].slice(0, position), `[[${item}]]`, this.notice[`${this.activeTypeMessage}_message`].slice(position)].join("");
        },
        async getData() {
            await this.$system.setGlobalSettings(true)
            this.rows = Object.keys(this.noticeVariables).map(key => {
                let item = {
                    name: key,
                    title: this.noticeVariables[key].title,
                    actions: false
                };
                this.noticeTypes.forEach((type) => {
                    item[type] = Object.hasOwn(this.$system.settings, `${key}_${type}_active`) ? this.$system.settings[`${key}_${type}_active`] : null;
                    if (Object.hasOwn(this.$system.settings, `${key}_${type}_message`))
                        item[`${type}_message`] = this.$system.settings[`${key}_${type}_message`];
                });
                return item;
            });
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.getData();
            this.$loading.finish();
        });
    },
};
</script>
